import { styled } from '@mui/material/styles';
import { Box, Grid, ListItemText, Paper, TableContainer, Typography } from '@mui/material';

export const CategoryPackDeepDiveContainer = styled(Box)({
  margin: '1% auto',
  padding: '1%',
  marginTop: '14px',
  backgroundColor: 'white',
  borderRadius: '5px',
  width: '100%',
  border: '0.91px solid #E5E5E5',
  maxWidth: '1265.01px',
});

export const DecompositionContainer = styled(Box)({
  margin: '1% auto',
  padding: '1%',
  marginTop: '54px',
  backgroundColor: 'white',
  borderRadius: '5px',
  width: '100%',
  maxWidth: '1265.01px',
});

export const ReviewTableContainer = styled(TableContainer)(() => ({
  width: '100%',
  maxHeight: '400px',
  overflowY: 'auto',
  position: 'relative',
  borderRadius: '4px',
  overflowX: 'hidden',
  '&:hover': {
    overflow: 'auto',
    overflowX: 'hidden',
  },
}));

export const MenuContainer = styled('div')(() => ({
  overflowY: 'hidden',
  '&:hover': {
    overflowY: ' auto',
  },
}));

export const ScenarioMenuContainer = styled(Grid)(() => ({
  height: '161px',
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '10px',
  lineHeight: '13.35px',
  marginRight: '5px',
  color: theme.palette.text.primary,
}));

export const DropdownContainer = styled('div')(() => ({
  position: 'relative',
  maxHeight: '297px',
  overflow: 'none',
  borderRadius: '10px',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '9px !important',
  lineHeight: '13.35px !important',
  padding: 0,
  '& .MuiTypography-root': {
    fontSize: '9px !important',
    color: theme.palette.text.primary,
    padding: 0,
    paddingTop: '4px',
  },
  height: '20px',
}));

export const DropdDownGrid = styled(Grid)(() => ({
  height: '229px',
  overflowY: 'auto',
}));
